import styled from 'styled-components';
import Button from '@womcorp/wom-miwom-ui-kit/dist/components/Button';

const ButtonStyled = styled(Button)`
  && {
    margin: 24px 0 8px;
    max-width: 280px;
  }
`;

export default ButtonStyled;
